import Cookies from "js-cookie";
// cookie保存的天数
import config from "@/config";
const { cookieExpires, cookieIsList } = config;

export const TOKEN_KEY = "jnj-token";

export const ISLAST_KEY = "jnj-isLast";

export const NAME_KEY = "name-key";

export const USER_AUTHORITY = "user-authority";

export const USER_INFO = "user-info";

export const USER_INFO_LIST = "user-info-list";

export const DIALOG = "dialog";

export const POPUP = "popup";

export const SYSTEM = "system";

export const USERACCOUNTNAME = "userAccount";

export const setToken = token => {
  Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 });
};

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);
  // console.log(token)
  if (token) return token;
  else return false;
};

export const setIsLast = isLast => {
  Cookies.set(ISLAST_KEY, isLast);
};

export const getIsLast = () => {
  const isLast = Cookies.get(ISLAST_KEY);
  if (isLast) return isLast;
  else return false;
};

export const setAuthority = authority => {
  Cookies.set(USER_AUTHORITY, authority);
};

export const getUserInfo = () => {
  const userInfo = Cookies.get(USER_INFO);
  if (userInfo) return userInfo;
  else return false;
};

export const setUserInfo = userInfo => {
  Cookies.set(USER_INFO, userInfo);
};

export const getUserInfoList = () => {
  const userInfoList = Cookies.get(USER_INFO_LIST);
  if (userInfoList) return userInfoList;
  else return [];
};

export const setUserInfoList = userInfoList => {
  Cookies.set(USER_INFO_LIST, userInfoList);
};

export const getAuthority = () => {
  const authority = Cookies.get(USER_AUTHORITY);
  if (authority) return authority;
  else return false;
};

export const setDialog = dialog => {
  Cookies.set(DIALOG, dialog);
};

export const getDialog = () => {
  const dialog = Cookies.get(DIALOG);
  if (dialog) return dialog;
  else return false;
};

export const setName = userName => {
  Cookies.set(NAME_KEY, userName);
};

export const getName = () => {
  const userName = Cookies.get(NAME_KEY);
  if (userName) return userName;
  else return "";
};

export const setPopUp = userName => {
  Cookies.set(POPUP, userName);
};

export const getPopUp = () => {
  const userName = Cookies.get(POPUP);
  if (userName) return userName;
  else return "";
};

export const setSystem = system => {
  Cookies.set(SYSTEM, system);
};

export const getSystem = () => {
  const system = Cookies.get(SYSTEM);
  if (system) return system;
  else return 0;
};

export const setUserAccount = userAccount => {
  Cookies.set(USERACCOUNTNAME, userAccount);
};

export const getUserAccount = () => {
  const userAccount = Cookies.get(USERACCOUNTNAME);
  if (userAccount) return userAccount;
  else return '';
};



// WEBPACK FOOTER //
// ./src/util/index.js